import { FC } from 'react';

import { ImageFade } from '@rikstv/play-common/src/components/imageFade/ImageFade';
import { H2 } from '@rikstv/shared-components';

import { StrimStartPageResponse } from '../../../../apis/sanityClient';
import { PortableTextToRDS } from '../../../../common/components/sanityComponents/blockContent';
import { ReactComponent as DevicesSvg } from '../../../../images/devices-light-inline.svg';

import style from './AppContent.module.css';

export const AppContent: FC<{ data: StrimStartPageResponse }> = ({ data }) => {
  if (!data.devicePromo) {
    return null;
  }

  const { devicePromo } = data;

  return (
    <div className={style.appContent}>
      <div className={style.container}>
        <H2>{devicePromo.title}</H2>
        <picture className={style.illustration}>
          <DevicesSvg aria-label="Enheter du kan bruke til Strim" />
        </picture>
        <PortableTextToRDS content={devicePromo.text} />
      </div>
      {devicePromo.devicePromoImageUrl && (
        <picture>
          <source srcSet={devicePromo.devicePromoImageUrl} type="image/webp" />
          <ImageFade
            src={devicePromo.devicePromoImageUrl}
            srcSet=""
            alt="Sånn bruker du Strim - en oversikt over hvilke enheter man kan bruke"
            className={style.image}
          />
        </picture>
      )}
    </div>
  );
};
